import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getLocationData: {
    loading: false,
    error: null,
    data: null,
  },
  addLocationData: {
    loading: false,
    error: null,
    data: null,
  },
  deleteLocation: {
    loading: false,
    error: null,
    data: null,
  },
  editLocation: {
    loading: false,
    error: null,
    data: null,
  },
  selectedLocation: {
    loading: false,
    error: null,
    data: null,
  },
  getPermissionLocationData: {
    loading: false,
    error: null,
    data: null,
  },
};

const locationSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
   
    getLocationDataStart: (state) => {
      state.getLocationData.loading = true;
      state.getLocationData.error = null;
      state.getLocationData.data = null;
    },
    getLocationDataSuccess: (state, action) => {
      state.getLocationData.loading = false;
      state.getLocationData.data = action.payload;
      state.getLocationData.error = null;
    },
    getLocationDataFailure: (state, action) => {
      state.getLocationData.loading = false;
      state.getLocationData.error = action.payload;
      state.getLocationData.data = null;
    },
    getLocationDataReset: (state, action) => {
      state.addLocationData.loading = false;
      state.addLocationData.error = null;
      state.addLocationData.data = null;
    },
    addLocationStart: (state) => {
      state.addLocationData.loading = true;
      state.addLocationData.error = null;
      state.addLocationData.data = null;
    },
    addLocationSuccess: (state, action) => {
      state.addLocationData.loading = false;
      state.addLocationData.data = action.payload;
      state.addLocationData.error = null;
    },
    addLocationFailure: (state, action) => {
      state.addLocationData.loading = false;
      state.addLocationData.error = action.payload;
      state.addLocationData.data = null;
    },
    addLocationResetForm: (state, action) => {
      state.addLocationData.loading = false;
      state.addLocationData.error = null;
      state.addLocationData.data = null;
    },

    deleteLocationStart: (state) => {
      state.deleteLocation.loading = true;
      state.deleteLocation.error = null;
      state.deleteLocation.data = null;
    },
    deleteLocationSuccess: (state, action) => {
      state.deleteLocation.loading = false;
      state.deleteLocation.data = action.payload;
      state.deleteLocation.error = null;
    },
    deleteLocationFailure: (state, action) => {
      state.deleteLocation.loading = false;
      state.deleteLocation.error = action.payload;
      state.deleteLocation.data = null;
    },
    deleteLocationResetForm: (state, action) => {
      state.deleteLocation.loading = false;
      state.deleteLocation.error = null;
      state.deleteLocation.data = null;
    },

    editLocationStart: (state) => {
      state.editLocation.loading = true;
      state.editLocation.error = null;
      state.editLocation.data = null;
    },
    editLocationSuccess: (state, action) => {
      state.editLocation.loading = false;
      state.editLocation.data = action.payload;
      state.editLocation.error = null;
    },
    editLocationFailure: (state, action) => {
      state.editLocation.loading = false;
      state.editLocation.error = action.payload;
      state.editLocation.data = null;
    },
    editLocationResetForm: (state, action) => {
      state.editLocation.loading = false;
      state.editLocation.error = null;
      state.editLocation.data = null;
    },

    selectedLocationStart: (state) => {
      state.selectedLocation.loading = true;
      state.selectedLocation.error = null;
      state.selectedLocation.data = null;
    },
    selectedLocationSuccess: (state, action) => {
      state.selectedLocation.loading = false;
      state.selectedLocation.data = action.payload;
      state.selectedLocation.error = null;
    },
    selectedLocationFailure: (state, action) => {
      state.selectedLocation.loading = false;
      state.selectedLocation.error = action.payload;
      state.selectedLocation.data = null;
    },
    selectedLocationResetForm: (state, action) => {
      state.selectedLocation.loading = false;
      state.selectedLocation.error = null;
      state.selectedLocation.data = null;
    },
    
    getPermissionLocationDataStart: (state) => {
      state.getPermissionLocationData.loading = true;
      state.getPermissionLocationData.error = null;
      state.getPermissionLocationData.data = null;
    },
    getPermissionLocationDataSuccess: (state, action) => {
      state.getPermissionLocationData.loading = false;
      state.getPermissionLocationData.data = action.payload;
      state.getPermissionLocationData.error = null;
    },
    getPermissionLocationDataFailure: (state, action) => {
      state.getPermissionLocationData.loading = false;
      state.getPermissionLocationData.error = action.payload;
      state.getPermissionLocationData.data = null;
    },
  },
});

export const {
  getLocationDataStart,
  getLocationDataFailure,
  getLocationDataSuccess,
  getLocationDataReset,

  getPermissionLocationDataFailure,
  getPermissionLocationDataStart,
  getPermissionLocationDataSuccess,

  addLocationStart,
  addLocationSuccess,
  addLocationFailure,
  addLocationResetForm,

  editLocationStart,
  editLocationSuccess,
  editLocationFailure,
  editLocationResetForm,

  deleteLocationStart,
  deleteLocationSuccess,
  deleteLocationFailure,
  deleteLocationResetForm,

  selectedLocationStart,
  selectedLocationSuccess,
  selectedLocationFailure,
  selectedLocationResetForm,

} = locationSlice.actions;

export default locationSlice.reducer;
